
<div class="fx_login_content">
  <form [formGroup]="myGroup">
      <!-- <div class="login-form-forgot" dw-col [dwSpan]="8" *ngIf="showLanguage">
          <dw-select formControlName="language" [dwPlaceHolder]="'搜尋..'" [dwShowSearch]="true">
            <dw-option *ngFor="let language of languageList" [dwLabel]="language.label" [dwValue]="language.value">
            </dw-option>
          </dw-select>
        </div> -->
  </form>

  <div class="fx_login_form_group">
      <div class="fx_login_status" *ngIf="!isPassword" style="padding-left: 25%;padding-right: 25%;">
          <!-- <div class="fx_login_welcome">
            <h1>您好、</h1>
            <h1>欢迎使用<span>OCSS</span></h1>
          </div> -->
          <div class="fx_login_title d-flex" style="justify-content: center;align-items: center;">
            <img style="width: 112px;height: 40px;" src="assets/img/home/444.png">
            <h2 style="font-size: 28px;padding-left: 20px;color: #000;font-weight: 500;">{{'fxed020-用户登录' | translate}}</h2>
          </div>
          <form dw-form [formGroup]="validateForm" class="login-form fx_login_form" (ngSubmit)="submitForm()">
            <!-- <dw-form-item class="login-username" [ngClass]="{'hasBorder': isFouce == 1}">
              <dw-input-group dwPrefixIcon="anticon iconSvg iconSvg_01" (click)="isBorder('1')">
                <input dw-input formControlName="ent" (change)="getParameter()" [placeholder]="'dw-login-tenant' | translate" [dwSize]="'large'">
              </dw-input-group>
            </dw-form-item> -->
            <dw-form-item class="login-username" [ngClass]="{'hasBorder': isFouce == 2}">
              <dw-input-group  (click)="isBorder('2')">
                <input style="border-radius: 6px!important;background-color: #F2F2F2;height: 48px;" dw-input formControlName="userId" [placeholder]="'dw-login-account' | translate" [dwSize]="'large'">
              </dw-input-group>
            </dw-form-item>
            <dw-form-item class="login-password" [ngClass]="{'hasBorder': isFouce == 3}" style="margin-top: 30px;">
              <dw-input-group  (click)="isBorder('3')">
                <input style="border-radius: 6px!important;background-color: #F2F2F2;height: 48px;" dw-input formControlName="password" [type]="showPassword ? 'text' : 'password'" [placeholder]="'dw-login-password' | translate" [dwSize]="'large'">
                <i style="margin-top: 8px;" [class]="showPassword ? 'anticon anticon-eye-o fx_eye' : 'anticon anticon-eye fx_eye'"
                   [ngClass]="{'eye_blue':showPassword}" (click)="showPassword = !showPassword"></i>
              </dw-input-group>
            </dw-form-item>
      <!--      <dw-form-item class="login-captcha" *ngIf="showCaptcha">
              <div dw-col class="dw-f-btn" [dwSpan]="16">
                  <input dw-input class="code" formControlName="captchaKey" type="text" placeholder="{{'fxed020-请输入验证码' | translate}}">
              </div>
              <div dw-col class="dw-f-btn" [dwSpan]="8">
                <div class="vailCode">
                  <img [src]="image_data" alt=""/>
                  <a href="javascript:void(0);" (click)="reloadVerifyImage()"><i class="anticon anticon-sync"></i></a>
                </div>
              </div>
            </dw-form-item>-->

            <dw-form-item class="login-btn" style="margin-top: 60px;">
              <dw-form-control>
                <button type="button" [disabled]="validateForm.invalid || isDisabled" class="login-form-button btn btn-danger" style="border-radius: 6px;height: 48px;"
                  (click)="login()">{{ 'dw-login-signIn' | translate}}</button>
              </dw-form-control>
            </dw-form-item>

            <dw-form-item class="login-remember" [ngClass]="{'en_US':language==='en_US','zh_CN':language==='zh_CN'}" style="display: flex;justify-content: center;align-items: center; text-align: center">
<!--              <a (click)="forgetP()" routerLinkActive="router-link-active" ><span [translate]="'dw-login-forgetPassword'"></span></a>-->
              <a style="margin-left: 1.5rem;" (click)="onRegister()" routerLinkActive="router-link-active" ><span>{{'fxed020-注册' | translate}}</span></a>
            </dw-form-item>
          </form>
        </div>

        <div class="fx_forget_form" *ngIf="isPassword" [@flyInOut]="'in'">
          <dw-forget-block [verificationType]="verificationType" [userId]="validateForm.get('userId').value" (canceled) = onCancel() ></dw-forget-block>
        </div>
        <div class="d-flex"
         style="color: #DC3545;font-size: 13px;justify-content: center">
      <span>温馨提示：尊敬的顾客,请先登录或注册,再挑宝贝哦！如需重置密码请联系客服人员！</span>
    </div>
  </div>

</div>



